import React, { useState } from 'react';
import AttachmentUpload from './AttachmentUpload';

const CruiseForm = ({ onSave, onCancel, initialData }) => {
  const [formData, setFormData] = useState({
    title: initialData?.title || '',
    carrier: initialData?.carrier || '',
    ship: initialData?.ship || '',
    stateroom: initialData?.stateroom || '',
    departsFrom: initialData?.departsFrom || '',
    departureDate: initialData?.departureDate || '',
    departureTime: initialData?.departureTime || '',
    numberOfPorts: initialData?.numberOfPorts || '',
    arrivesIn: initialData?.arrivesIn || '',
    arrivalDate: initialData?.arrivalDate || '',
    arrivalTime: initialData?.arrivalTime || '',
    confirmationNumber: initialData?.confirmationNumber || '',
    description: initialData?.description || '',
    price: initialData?.price || '',
    depositRequired: initialData?.depositRequired || false,
    depositAmount: initialData?.depositAmount || '',
    depositDueDate: initialData?.depositDueDate || '',
    isOption: initialData?.isOption || false,
    optionDescription: initialData?.optionDescription || '',
    paymentTiming: initialData?.paymentTiming || 'with_deposit',
    optionalDepositAmount: initialData?.optionalDepositAmount || '',
    photos: initialData?.photos || [],
    documents: initialData?.documents || []
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      ...formData,
      type: 'cruise',
      price: parseFloat(formData.price) || 0,
      paymentTiming: formData.paymentTiming,
      optionalDepositAmount: formData.optionalDepositAmount ? parseFloat(formData.optionalDepositAmount) : null,
      depositAmount: formData.depositRequired ? parseFloat(formData.depositAmount) || 0 : 0
    });
  };

  return (
    <form onSubmit={handleSubmit} className="component-form cruise-form">
      <div className="form-section">
        <h4>Cruise Information</h4>
        
        <div className="form-group">
          <label>Title/Description*</label>
          <input
            type="text"
            value={formData.title}
            onChange={(e) => setFormData({...formData, title: e.target.value})}
            placeholder="e.g., 7-Day Caribbean Cruise"
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Cruise Line*</label>
            <input
              type="text"
              value={formData.carrier}
              onChange={(e) => setFormData({...formData, carrier: e.target.value})}
              placeholder="e.g., Royal Caribbean"
              required
            />
          </div>
          <div className="form-group">
            <label>Ship Name*</label>
            <input
              type="text"
              value={formData.ship}
              onChange={(e) => setFormData({...formData, ship: e.target.value})}
              placeholder="e.g., Symphony of the Seas"
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Stateroom Type</label>
            <input
              type="text"
              value={formData.stateroom}
              onChange={(e) => setFormData({...formData, stateroom: e.target.value})}
              placeholder="e.g., Balcony Stateroom"
            />
          </div>
          <div className="form-group">
            <label>Number of Ports</label>
            <input
              type="number"
              value={formData.numberOfPorts}
              onChange={(e) => setFormData({...formData, numberOfPorts: e.target.value})}
              placeholder="e.g., 4"
              min="0"
            />
          </div>
        </div>
      </div>

      <div className="form-section">
        <h4>Departure Information</h4>
        
        <div className="form-row">
          <div className="form-group">
            <label>Departs From*</label>
            <input
              type="text"
              value={formData.departsFrom}
              onChange={(e) => setFormData({...formData, departsFrom: e.target.value})}
              placeholder="e.g., Port Canaveral, FL"
              required
            />
          </div>
          <div className="form-group">
            <label>Departure Date*</label>
            <input
              type="date"
              value={formData.departureDate}
              onChange={(e) => setFormData({...formData, departureDate: e.target.value})}
              required
            />
          </div>
          <div className="form-group">
            <label>Departure Time</label>
            <input
              type="time"
              value={formData.departureTime}
              onChange={(e) => setFormData({...formData, departureTime: e.target.value})}
            />
          </div>
        </div>
      </div>

      <div className="form-section">
        <h4>Arrival Information</h4>
        
        <div className="form-row">
          <div className="form-group">
            <label>Arrives In*</label>
            <input
              type="text"
              value={formData.arrivesIn}
              onChange={(e) => setFormData({...formData, arrivesIn: e.target.value})}
              placeholder="e.g., Port Canaveral, FL"
              required
            />
          </div>
          <div className="form-group">
            <label>Arrival Date*</label>
            <input
              type="date"
              value={formData.arrivalDate}
              onChange={(e) => setFormData({...formData, arrivalDate: e.target.value})}
              required
            />
          </div>
          <div className="form-group">
            <label>Arrival Time</label>
            <input
              type="time"
              value={formData.arrivalTime}
              onChange={(e) => setFormData({...formData, arrivalTime: e.target.value})}
            />
          </div>
        </div>
      </div>

      <div className="form-section">
        <h4>Booking Details</h4>
        
        <div className="form-row">
          <div className="form-group">
            <label>Confirmation Number</label>
            <input
              type="text"
              value={formData.confirmationNumber}
              onChange={(e) => setFormData({...formData, confirmationNumber: e.target.value})}
              placeholder="e.g., ABC123456"
            />
          </div>
          <div className="form-group">
            <label>Price*</label>
            <input
              type="number"
              value={formData.price}
              onChange={(e) => setFormData({...formData, price: e.target.value})}
              placeholder="0.00"
              min="0"
              step="0.01"
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>Additional Description</label>
          <textarea
            value={formData.description}
            onChange={(e) => setFormData({...formData, description: e.target.value})}
            placeholder="Add any additional details about this cruise..."
            rows="3"
          />
        </div>
      </div>

      <div className="form-section">
        <h4>Deposit Information</h4>
        
        <div className="form-row">
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={formData.depositRequired}
                onChange={(e) => setFormData({...formData, depositRequired: e.target.checked})}
              />
              Deposit Required
            </label>
          </div>
        </div>

        {formData.depositRequired && (
          <div className="form-row">
            <div className="form-group">
              <label>Deposit Amount*</label>
              <input
                type="number"
                value={formData.depositAmount}
                onChange={(e) => setFormData({...formData, depositAmount: e.target.value})}
                placeholder="0.00"
                min="0"
                step="0.01"
                required
              />
            </div>
            <div className="form-group">
              <label>Deposit Due Date</label>
              <input
                type="date"
                value={formData.depositDueDate}
                onChange={(e) => setFormData({...formData, depositDueDate: e.target.value})}
              />
            </div>
          </div>
        )}
      </div>

      <div className="form-section">
        <h4>Client Options</h4>
        
        <div className="form-row">
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                checked={formData.isOption}
                onChange={(e) => setFormData({...formData, isOption: e.target.checked})}
              />
              Mark as Optional for Client
            </label>
            <small className="form-help">
              When checked, clients can choose whether to include this component in their booking
            </small>
          </div>
        </div>

        {formData.isOption && (
          <>
            <div className="form-group">
              <label>Option Description for Client</label>
              <textarea
                value={formData.optionDescription}
                onChange={(e) => setFormData({...formData, optionDescription: e.target.value})}
                placeholder="e.g., Optional cruise upgrade or cabin category"
                rows="2"
              />
              <small className="form-help">
                This description helps clients understand what this option includes
              </small>
            </div>

            <div className="form-group">
              <label>Payment Timing for Optional Component</label>
              <select
                value={formData.paymentTiming}
                onChange={(e) => setFormData({...formData, paymentTiming: e.target.value})}
                className="form-control"
              >
                <option value="immediate">Pay Full Price When Selected (e.g., cruise excursions)</option>
                <option value="with_deposit">Pay Deposit When Selected</option>
                <option value="with_final">Pay with Final Payment (nothing due initially)</option>
                <option value="bundled">Already Included in Package (no additional payment)</option>
              </select>
              <small className="form-help">
                Choose when payment is due if client selects this option
              </small>
            </div>

            {formData.paymentTiming === 'with_deposit' && (
              <div className="form-group">
                <label>Optional Component Deposit Amount ($)</label>
                <input
                  type="number"
                  value={formData.optionalDepositAmount}
                  onChange={(e) => setFormData({...formData, optionalDepositAmount: e.target.value})}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                  className="form-control"
                />
                <small className="form-help">
                  Amount due when client selects this option (leave blank for full price)
                </small>
              </div>
            )}
          </>
        )}
      </div>

      <AttachmentUpload
        photos={formData.photos}
        documents={formData.documents}
        onPhotosChange={(photos) => setFormData({...formData, photos})}
        onDocumentsChange={(documents) => setFormData({...formData, documents})}
        maxPhotos={5}
        maxDocuments={3}
        showPhotos={true}
        showDocuments={true}
      />

      <div className="form-actions">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="btn btn-primary">
          {initialData ? 'Update' : 'Add'} Cruise
        </button>
      </div>
    </form>
  );
};

export default CruiseForm;
